/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promotions_PlaceholderInputs */

const id_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /promotions/$id!`)
};

const ms_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /promotions/$id!`)
};

const da_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /promotions/$id!`)
};

const de_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /promotions/$id!`)
};

const en_us2_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /promotions/$id!`)
};

const es_es2_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /promotions/$id!`)
};

const es_mx2_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /promotions/$id!`)
};

const fil_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /promotions/$id!`)
};

const fr_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour /promotions/$id !`)
};

const it_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao /promotions/$id!`)
};

const hu_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szia /promotions/$id!`)
};

const nl_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /promotions/$id!`)
};

const no_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /promotions/$id!`)
};

const pl_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj /promotions/$id!`)
};

const pt_br2_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /promoções/$id!`)
};

const pt_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /promotions/$id!`)
};

const ro_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salut /promotions/$id!`)
};

const fi_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /promotions/$id!`)
};

const sv_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /promotions/$id!`)
};

const vi_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào /promotions/$id!`)
};

const tr_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba /promotions/$id!`)
};

const cs_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahoj /promotions/$id!`)
};

const bg_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравейте /promotions/$id!`)
};

const ru_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, /promotions/$id!`)
};

const uk_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привіт /promotions/$id!`)
};

const ar_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا /promotions/$id!`)
};

const hi_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमस्ते /promotions/$id!`)
};

const th_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดี /promotions/$id!`)
};

const ja_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんにちは /promotions/$id!`)
};

const zh_cn2_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你好 /promotions/$id!`)
};

const zh_hant1_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你好 /promotions/$id！`)
};

const ko_promotions_placeholder = /** @type {(inputs: Promotions_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/promotions/$id에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Hello /promotions/$id!" |
*
* @param {Promotions_PlaceholderInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const promotions_placeholder = /** @type {((inputs?: Promotions_PlaceholderInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promotions_PlaceholderInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_promotions_placeholder(inputs)
	if (locale === "ms") return ms_promotions_placeholder(inputs)
	if (locale === "da") return da_promotions_placeholder(inputs)
	if (locale === "de") return de_promotions_placeholder(inputs)
	if (locale === "en-US") return en_us2_promotions_placeholder(inputs)
	if (locale === "es-ES") return es_es2_promotions_placeholder(inputs)
	if (locale === "es-MX") return es_mx2_promotions_placeholder(inputs)
	if (locale === "fil") return fil_promotions_placeholder(inputs)
	if (locale === "fr") return fr_promotions_placeholder(inputs)
	if (locale === "it") return it_promotions_placeholder(inputs)
	if (locale === "hu") return hu_promotions_placeholder(inputs)
	if (locale === "nl") return nl_promotions_placeholder(inputs)
	if (locale === "no") return no_promotions_placeholder(inputs)
	if (locale === "pl") return pl_promotions_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_promotions_placeholder(inputs)
	if (locale === "pt") return pt_promotions_placeholder(inputs)
	if (locale === "ro") return ro_promotions_placeholder(inputs)
	if (locale === "fi") return fi_promotions_placeholder(inputs)
	if (locale === "sv") return sv_promotions_placeholder(inputs)
	if (locale === "vi") return vi_promotions_placeholder(inputs)
	if (locale === "tr") return tr_promotions_placeholder(inputs)
	if (locale === "cs") return cs_promotions_placeholder(inputs)
	if (locale === "bg") return bg_promotions_placeholder(inputs)
	if (locale === "ru") return ru_promotions_placeholder(inputs)
	if (locale === "uk") return uk_promotions_placeholder(inputs)
	if (locale === "ar") return ar_promotions_placeholder(inputs)
	if (locale === "hi") return hi_promotions_placeholder(inputs)
	if (locale === "th") return th_promotions_placeholder(inputs)
	if (locale === "ja") return ja_promotions_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_promotions_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_promotions_placeholder(inputs)
	return ko_promotions_placeholder(inputs)
});
export { promotions_placeholder as "promotions.placeholder" }